import {DelayedLoadingContainer} from './delayed-loading-container';
import {logger} from '../utils/logger';
import {css} from '@emotion/react';
import {Alert, Center, Group, Loader} from '@mantine/core';
import {FC, PropsWithChildren} from 'react';

const log = logger('AsyncStateContainer');

type AsyncStateContainer = PropsWithChildren<{
  loading: boolean;
  error?: Error;
  delayInMs?: number;
  loadingMessage?: string;
  inline?: boolean;
}>;

export const AsyncStateContainer: FC<AsyncStateContainer> = (props) => {
  const {loading, error, children, delayInMs, loadingMessage, inline} = props;
  if (loading) {
    return (
      <div css={containerStyle}>
        {children}
        <DelayedLoadingContainer delayInMs={delayInMs}>
          <div css={overlayStyle}>
            <Center inline={inline} component={Group}>
              <Loader />
              {loadingMessage}
            </Center>
          </div>
        </DelayedLoadingContainer>
      </div>
    );
  }

  if (error) {
    log.error(error.message, error);
    return (
      <Alert color={'red'} variant={'light'}>
        {error.message}
        {error.stack && <pre>{error.stack}</pre>}
      </Alert>
    );
  }

  return children;
};

const containerStyle = css({
  position: 'relative',
});

const overlayStyle = css({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1,
});
